import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-secondary',
  templateUrl: './secondary.component.html',
  styleUrls: ['./secondary.component.scss'],
})
export class SecondaryComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
